import { IMealInput, IQueryConfigArgs } from "../../common/types";
import { db, collectionWithArgs } from "./firestoreService";
import { COLLECTION_MEALS } from "./firebaseConstants";

export function fetchMealsFromFirestore(args?: IQueryConfigArgs[]) {
  const ref = db.collection(COLLECTION_MEALS);
  return collectionWithArgs(ref, args || []);
}
export function listenToMealFromFirestore(id: string) {
  return db.collection(COLLECTION_MEALS).doc(id);
}

export function addMealToFirestore(doc: IMealInput) {
  // const user = firebase.auth().currentYachit;
  return db.collection(COLLECTION_MEALS).add({
    ...doc,
    createDate: new Date(),
    // createBy: user,
  });
}

export function updateMealInFirestore(docId: string, doc: IMealInput | any) {
  return db.collection(COLLECTION_MEALS).doc(docId).update(doc);
}

export function activeToggleMealInFirestore(docId: string, status: boolean) {
  return db.collection(COLLECTION_MEALS).doc(docId).update({
    status,
  });
}

export function deleteMealInFirestore(docId: string) {
  return db.collection(COLLECTION_MEALS).doc(docId).delete();
}
